
import { Component, Vue, Prop } from "vue-property-decorator";
import IntroduceCard from "@/views/ai-builder-component/components/introduce-card.vue";
import { ExamVersionInfo } from "@/lib/model/exambuilder/exam-component/exam";
import Editor5 from "@/components/editor/classic-editor5.vue";
import HinaInput from "@/views/ai-builder-component/baseComponent/hina-input.vue";
import HinaTextarea from "@/views/ai-builder-component/baseComponent/hina-textarea.vue";
import HinaSwitch from "@/views/ai-builder-component/baseComponent/hina-switch.vue";
import { ElForm } from "element-ui/types/form";

@Component({
  components: {
    HinaInput,
    HinaTextarea,
    Editor5,
    IntroduceCard,
    HinaSwitch
  }
})
export default class Signature extends Vue {
  @Prop({}) formItemData!: ExamVersionInfo;

  rules = {
    title: [
      {
        required: true,
        message: "请输入标题",
        trigger: "blur"
      }
    ],
    desc: [
      {
        required: true,
        message: "请输入内容",
        trigger: ["blur", "change"]
      }
    ],
    buttonText: [
      {
        required: true,
        message: "请输入按钮名称",
        trigger: "blur"
      }
    ],
    noticeMessage: [
      {
        required: true,
        message: "请输入签名板提示信息",
        trigger: "blur"
      }
    ]
  };

  changeValid(val: number) {
    if (val !== 1) {
      this.$emit("setBar", false);
    }
  }

  formItemCheck() {
    this.formItemData.signatureConfig.configData.title = this.formItemData.signatureConfig.configData.title.trim();
    this.formItemData.signatureConfig.configData.buttonText = this.formItemData.signatureConfig.configData.buttonText.trim();
    this.formItemData.signatureConfig.configData.noticeMessage = this.formItemData.signatureConfig.configData.noticeMessage.trim();

    return new Promise(resolve => {
      (this.$refs.formRef as ElForm)
        .validate()
        .then(() => resolve(""))
        .catch(() => resolve("signature"));
    });
  }
}
